module.exports = __webpack_public_path__ + "img/pop_001@2x.dad4d23a.png";